import { z } from 'zod';
import { route, defineContract } from '../core/types';
import { requiredStringSchema } from '../schemas';
import { activityLabelSchema } from '../../interfaces/IActivityLabel';

// ============================================================
// Param Schemas
// ============================================================

const projectParamsSchema = z.object({
	projectId: requiredStringSchema,
});

const labelParamsSchema = projectParamsSchema.extend({
	labelId: requiredStringSchema,
});

// ============================================================
// Contract
// ============================================================

/**
 * `{ root: true }` because each route spells its own full path: the project is a
 * PATH PARAM, so it has to precede the collection segment, which the contract-name
 * prefix cannot express.
 */
export const labelContract = defineContract(
	'labels',
	{
		getLabelsByProjectId: route({
			method: 'GET',
			path: '/projects/:projectId/labels',
			params: projectParamsSchema,
			response: z.array(activityLabelSchema),
			operationId: 'getLabelsByProjectId',
			tags: ['Labels'],
			summary: 'Get all labels for a project',
		}),
		getLabelById: route({
			method: 'GET',
			path: '/projects/:projectId/labels/:labelId',
			params: labelParamsSchema,
			response: z.union([z.null(), activityLabelSchema]),
			operationId: 'getLabelById',
			tags: ['Labels'],
			summary: 'Get a label by ID',
		}),
		createLabel: route({
			method: 'POST',
			path: '/projects/:projectId/labels',
			params: projectParamsSchema,
			body: z.object({
				text: requiredStringSchema,
			}),
			response: z.string(),
			operationId: 'createLabel',
			tags: ['Labels'],
			summary: 'Create a new label',
		}),
		deleteLabel: route({
			method: 'DELETE',
			path: '/projects/:projectId/labels/:labelId',
			params: labelParamsSchema,
			response: z.string(),
			operationId: 'deleteLabelById',
			tags: ['Labels'],
			summary: 'Delete a label',
		}),
	},
	{ root: true }
);
